import { Component, Input } from '@angular/core';
import { Params } from '@angular/router';

@Component({
  selector: '[wl-nested-menu]',
  //directives: [ROUTER_DIRECTIVES, NestedMenuComponent],
  //pipes: [TranslatePipe],
  templateUrl: 'nested-menu.component.html',
  standalone: false,
})
export class NestedMenuComponent {
  @Input() dropdown: (MenuItemSeparator | MenuItem)[];

  ngOnInit() {
    for (let i in this.dropdown) if (!(<MenuItemSeparator>this.dropdown[i]).isSeparator) (<MenuItem>this.dropdown[i]).dropdownOpen = false;
  }

  public toggleMenuItemDropdown(menuItem: MenuItem) {
    let isOpen: boolean = menuItem.dropdownOpen;

    // close the rest
    for (let i in this.dropdown) if (!(<MenuItemSeparator>this.dropdown[i]).isSeparator) (<MenuItem>this.dropdown[i]).dropdownOpen = false;

    menuItem.dropdownOpen = !isOpen;
  }

  public refreshMenuItemUrl(item: MenuItem): void {
    if (item.refreshUrl) item.refreshUrl(item);
  }
}

export class MenuItemSeparator {
  public get isSeparator(): boolean {
    return true;
  }
}

export interface MenuItem {
  title: string;
  routerLink?: string | string[];
  url?: string;
  target?: string;
  dropdown?: (MenuItemSeparator | MenuItem)[];
  dropdownOpen?: boolean;
  click?(): void;
  id?: number;
  hidden?: boolean;
  refreshUrl?(item: MenuItem): void;
  noTranslate?: boolean;
  queryParams?: Params;
}
